import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import moment from 'moment';
import JisDialogForm from '../../components/formdialog';

function VacationCases() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({});
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isCmc, setIsCmc]=useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
    const [selected, setSelected] = useState(new Set()); //to hold the selected 
    const [roles, setRoles] = useState([]);
    const [judges, setJudges] = useState([]);
    const [selectedCases, setSelectedCases] = useState({});
    const [assignTo,setAssignTo]=useState(null);

    const [roleCase, setRoleCase]=useState('all');
    

   

      useEffect(() => {
        console.log('profile details')
        console.log(profile);
          onLoad();    
          onLoadVacationJudges()
    }, []);

    useEffect(() => {
      if(pageIndex>=0){

    if(!isSearch){
            onLoad(); 
          }else{
            onSearch(search);
          }
      }else{
        setPageIndex(0);
      }
      
                
    }, [pageIndex,pageSize,search]);


const onCheck=(value,opt)=>{
        let sel=selected;
        let updateSel={...selectedCases};
        if(value){
        sel.add(opt.caseId)
        updateSel[opt.caseId]=opt;
        }else{
         sel.delete(opt.caseId);
          delete updateSel[opt.caseId];
        }
        setSelected(new Set(sel));
        setSelectedCases(updateSel)
        console.log(Object.keys(updateSel))
    }
  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/case-assigment/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/vacation-cases/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.items)
               if(pageIndex==0){
                setCount(data.totalCount)
               }
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }

   
        const onLoadVacationJudges= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-vacation-judges`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setJudges(data.list)
               
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
 
      

      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

    const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }
 

   const onSave=async(e)=>{
             e.preventDefault();
             if(isCmc==null){
               setErr('Please select the Case Event Option');
               return;
             }

             if(assignTo==null){
               setErr('Please selecte one of the listed Judges');
               return;
             }
             
             var caseids=Array.from(selected);
             setErr('');
             var judgeAs=isCmc==true?'CMC':'Trial';
              var approve={...option,isCms:isCmc,caseids:caseids,assignType:'judge',judgeAs:judgeAs,assignTo:assignTo};
                
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenOption(false)
               
                if(isCmc==false){
                     setAlert({open:true, title:'Case Assignment', subtitle:'Trial Cases assigned successfully'});
                }else{
                    setAlert({open:true, title:'Case Assignment', subtitle:'CMC Cases assigned  successfully'});
                }
                setPageIndex(-1); // this will auto load again
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
 
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}

const onDirectSearch=(sear)=>{
   setSearch(sear)       ;
   setIsSearch(true);
  setPageIndex(0);
}

  return (
    <div>
     
      <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} caseprocess="Vacation"  />
      <div style={{textAlign:'right'}}>
        {Object.keys(selectedCases).length>0 && <JisButton onClick={()=> setOpenOption(true)}> Bulk Asign ({Object.keys(selectedCases).length})</JisButton>}  
      </div>
      
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Assignment Cases</span><span className='total'>{count}</span>
</div>
      <table className="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Case Age(Days)</th>
      <th>Date Filed</th>
      <th>Status Level</th>
  
      <th>Details</th>
      <th>Assign</th>
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => (
       <tr key={index} style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>
      <td>{opt.caseNumber}</td>
      <td>{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
      <td>{moment().diff(opt.createdOn, 'days')}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
       <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
      <td><JisCheckbox onChange={(e)=>onCheck(e,opt)} value={selected.has(opt.caseId)} /></td>
    </tr>
    ))} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
<BackLoader open={loading} />

  {openCase && active!=null  && <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
          </div>
</JisDialogForm>}
        
      {openOption && <JisDialogForm title=" Vacation Case Assignment" onClose={()=>setOpenOption(false)}>
                    <form onSubmit={onSave}>
                      <div style={{display:'flex'}}>
                         <div style={{flex:3}}>
                            <JisYesNo  label="Assign Case As... " value={isCmc} yes="CMC" no="Trial"  onChange={(e)=>setIsCmc(e) }/> 
                  
                              <div>
                                      
                                   
                                    <div className="select-group">
                                        <label>
                                            Judges: <strong style={{fontSize:12}}>(Please select one of the Judges) </strong>
                                        </label>
                                        <div className='content-box' style={{maxHeight:300}}>
                                           {judges?.map((opt) => (
                                            <div key={opt.id}  onClick={()=>setAssignTo(opt.id)} className={`selected ${opt.id==assignTo?'active':''}`}>
                                                {opt.judge.suffix} {opt.judge.firstName} {opt.judge.lastName} --- {Constants.getItemById(frequentData?.divisions,opt.divisionId)?.title} 
                                            </div>
                                            ))}
                                        </div>
                                        
                                    </div>
                                    

                              </div> 
                            <div  className="input-group">
                                <label>Comment <span className="required">*</span> </label>
                                <div className='input-wrapper'>
                                    <DynamicIcon iname="group" />
                                    <textarea placeholder=' Comment' name='comment' required={true}  value={option.comment}
                            onChange={onOptionChange }  />
                                </div>
                            </div> 
                            {err!="" && <div className='error'>{err}</div>}

                         
                            <JisButton type="submit">Save </JisButton>     <JisButton type="button" onClick={()=> setOpenOption(false)}>Cancel </JisButton>             
                        </div>
                        <div style={{flex:1,maxHeight:300}}  className='content-box'>
                          <div>
                            Selected Cases to Assign ({Object.values(selectedCases).length})
                          </div>
                          {Object.values(selectedCases)?.map((opt,index) => (
                                            <div className='selected' key={index} >
                                              <div>{opt.caseNumber}</div> 
                                              <p style={{fontSize:12}}>{opt.caseTitle}</p> 
                                            </div>
                                            ))}
                        </div>
                      </div>
                       
                    </form>
            </JisDialogForm>}    
    </div>
  );
}

export default VacationCases;